<template>
  <md-toolbar class="md-success">
    <div class="md-layout">
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-60 md-medium-size-50 md-large-size-50 md-xlarge-size-30"
      >
        <div class="md-layout md-alignment-top-left">
          <slot name="leftSide">
            <hierarchy-menu class="hierarchy-menu"></hierarchy-menu>
          </slot>
          <slot name="appliancesMenu"></slot>
        </div>
      </div>

      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-40 md-medium-size-50 md-large-size-50 md-xlarge-size-70"
        v-if="dateRangeMenu"
      >
        <div class="md-layout md-alignment-top-right">
          <!-- <drop-down :multiLevel="false" v-if="showSource">
            <md-button class="md-button md-info dropdown-toggle" data-toggle="dropdown">
              <i class="fas fa-sitemap"></i>
              {{selectedDataSource}}
            </md-button>

            <ul class="dropdown-menu dropdown-menu-right">
              <li>
                <a @click="setDataSource(1)">WiFi</a>
              </li>
              <li>
                <a v-if="selectedDevice.lora" @click="setDataSource(2)">LoRa</a>
                <span v-else class="disabled">LoRa</span>
              </li>
            </ul>
          </drop-down> -->

          <drop-down direction="down" :multiLevel="true">
            <md-button
              slot="title"
              class="md-button md-info dropdown-toggle"
              @click="closeCalendar"
            >
              <i class="far fa-calendar-alt"></i>
              {{selectedDateRange}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
              <li v-if="granularity === 'day'">
                <a @click="selectDateRange('today')">{{this.$lang.keys.today}}</a>
              </li>
              <li v-if="granularity === 'day'">
                <a @click="selectDateRange('yesterday')">{{this.$lang.keys.yesterday}}</a>
              </li>
              <li v-if="granularity === 'day'">
                <a @click="selectDateRange('last7days')">{{this.$lang.keys.last7days}}</a>
              </li>
              <li v-if="granularity === 'day'">
                <a @click="selectDateRange('last14days')">{{this.$lang.keys.last14days}}</a>
              </li>

              <li v-if="granularity === 'week'">
                <a @click="selectDateRange('last7days')">{{this.$lang.keys.last7days}}</a>
              </li>
              <li v-if="granularity === 'week'">
                <a @click="selectDateRange('last14days')">{{this.$lang.keys.last14days}}</a>
              </li>

              <li v-if="granularity === 'year'">
                <a @click="selectDateRange('thisYear')">{{this.$lang.keys.this_year}}</a>
              </li>
              <li v-if="granularity === 'year'">
                <a @click="selectDateRange('lastYear')">{{this.$lang.keys.last_year}}</a>
              </li>

              <li>
                <a
                  class="dropdown-toggle"
                  :class="{ open: dropDownCalendar }"
                  @click="toggleCalendar"
                >{{this.$lang.keys.calendar}}</a>
                <ul class="dropdown-menu dropdown-menu-left">
                  <v-date-picker
                    mode="range"
                    v-model="datePicker"
                    is-inline
                    :attributes="attrs"
                    :max-date="new Date()"
                    :firstDayOfWeek="2"
                  ></v-date-picker>
                </ul>
              </li>
            </ul>
          </drop-down>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import hierarchyMenu from "@/components/HierarchyMenu";

import start_of_today from "date-fns/start_of_today";
import end_of_today from "date-fns/end_of_today";
import start_of_yesterday from "date-fns/start_of_yesterday";
import end_of_yesterday from "date-fns/end_of_yesterday";
import sub_days from "date-fns/sub_days";
import format from "date-fns/format";

import start_of_day from "date-fns/start_of_day";
import end_of_day from "date-fns/end_of_day";

import { startOfYear, subYears, endOfYear } from "date-fns";

export default {
  name: "GraphToolBar",
  props: {
    granularity: {
      type: String,
      default: "day"
    },
    showSource: {
      type: Boolean,
      default: false
    },
    dateRangeMenu: {
      type: Boolean,
      default: true
    },
    showApplianceMenu: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "hierarchy-menu": hierarchyMenu
  },

  data() {
    return {
      attrs: [
        {
          key: "today",
          highlight: {
            backgroundColor: "#b1daf6"
          },
          dates: new Date()
        }
      ],
      datePicker: {
        start: null,
        end: null
      },
      selectedDateRange: "",
      selectedDataSource: "",
      dropDownCalendar: false
    };
  },

  computed: {
    selectedDate() {
      return this.$store.getters.getDateRange;
    },
    getDateRangeSelector() {
      return this.$store.getters.getDateRangeSelectors;
    },
    dataSource() {
      return this.$store.getters.getDateRangeSelectors.dataSource;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  watch: {
    datePicker() {
      this.selectedDateRange =
        format(start_of_day(this.datePicker.start), "D.M.") +
        " - " +
        format(start_of_day(this.datePicker.end), "D.M.");
      this.saveDateRange(
        this.selectedDateRange,
        format(start_of_day(this.datePicker.start), "X"),
        format(end_of_day(this.datePicker.end), "X")
      );

      this.$emit("on-selected", {
        device: !this.$slots.leftSide ? this.selectedDevice : null,
        date: {
          from: format(start_of_day(this.datePicker.start), "X"),
          to: format(end_of_day(this.datePicker.end), "X")
        },
        source: this.showSource ? this.dataSource : null
      });
    },

    selectedDevice: function(newVal, oldVal) {
      if (this.dataSource === 2 && newVal.lora === false) {
        this.setDataSource(1);
      } else {
        this.$emit("on-selected", {
          device: !this.$slots.leftSide ? this.selectedDevice : null,
          date: {
            from: format(start_of_day(this.datePicker.start), "X"),
            to: format(end_of_day(this.datePicker.end), "X")
          },
          source: this.showSource ? this.dataSource : null
        });
      }
    }
  },

  created() {
    switch (this.granularity) {
      case "day":
        this.setHumanDateRangeInLang(this.getDateRangeSelector.day.human);
        const selectedTS = this.getTimeStampByKey(this.getDateRangeSelector.day.human);
        if (selectedTS){
          this.datePicker.start = selectedTS.from * 1000;
          this.datePicker.end = selectedTS.to * 1000;
        } else {
          this.datePicker.start = this.getDateRangeSelector.day.from * 1000;
          this.datePicker.end = this.getDateRangeSelector.day.to * 1000;
        }
        break;
      case "week":
        this.setHumanDateRangeInLang(this.getDateRangeSelector.week.human);
        const selectedTS2 = this.getTimeStampByKey(this.getDateRangeSelector.week.human);
        if (selectedTS2){
          this.datePicker.start = selectedTS2.from * 1000;
          this.datePicker.end = selectedTS2.to * 1000;
        } else {
          this.datePicker.start = this.getDateRangeSelector.week.from * 1000;
          this.datePicker.end = this.getDateRangeSelector.week.to * 1000;
        }
        break;
      case "year":
        this.setHumanDateRangeInLang(this.getDateRangeSelector.year.human);
        const selectedTS3 = this.getTimeStampByKey(this.getDateRangeSelector.year.human);
        if (selectedTS3){
          this.datePicker.start = selectedTS3.from * 1000;
          this.datePicker.end = selectedTS3.to * 1000;
        } else {
          this.datePicker.start = this.getDateRangeSelector.year.from * 1000;
          this.datePicker.end = this.getDateRangeSelector.year.to * 1000;
        }
        break;
    }

    this.setHumanDataSource(this.dataSource);

    this.$emit("on-selected", {
      device: !this.$slots.leftSide ? this.selectedDevice : null,
      date: {
        from: format(start_of_day(this.datePicker.start), "X"),
        to: format(end_of_day(this.datePicker.end), "X")
      },
      source: this.showSource ? this.dataSource : null
    });
  },

  methods: {
    closeCalendar() {
      this.dropDownCalendar = false;
    },

    toggleCalendar() {
      this.dropDownCalendar = !this.dropDownCalendar;
    },

    setDataSource(source) {
      this.$store.commit("setDataSource", source);
      this.setHumanDataSource(source);

      this.$emit("on-selected", {
        device: !this.$slots.leftSide ? this.selectedDevice : null,
        date: {
          from: format(start_of_day(this.datePicker.start), "X"),
          to: format(end_of_day(this.datePicker.end), "X")
        },
        source: this.showSource ? this.dataSource : null
      });
    },

    selectDateRange(btnName) {
      const selectedTS = this.getTimeStampByKey(btnName);
      const startTS = selectedTS.from;
      const endTS = selectedTS.to;

      this.setHumanDateRangeInLang(btnName);
      this.saveDateRange(btnName, startTS, endTS);

      this.datePicker.start = new Date(parseInt(startTS) * 1000);
      this.datePicker.end = new Date(parseInt(endTS) * 1000);

      this.$emit("on-selected", {
        device: !this.$slots.leftSide ? this.selectedDevice : null,
        date: {
          from: startTS,
          to: endTS
        },
        source: this.showSource ? this.dataSource : null
      });
    },


    setHumanDataSource(key) {
      switch (key) {
        case 1:
          this.selectedDataSource = "WiFi";
          break;
        case 2:
          this.selectedDataSource = "LoRa";
          break;
      }
    },

    setHumanDateRangeInLang(key) {
      switch (key) {
        case "today":
          this.selectedDateRange = this.$lang.keys.today;
          break;
        case "yesterday":
          this.selectedDateRange = this.$lang.keys.yesterday;
          break;
        case "last7days":
          this.selectedDateRange = this.$lang.keys.last7days;
          break;
        case "last14days":
          this.selectedDateRange = this.$lang.keys.last14days;
          break;
        case "thisYear":
          this.selectedDateRange = this.$lang.keys.this_year;
          break;
        case "lastYear":
          this.selectedDateRange = this.$lang.keys.last_year;
          break;
        default:
          this.selectedDateRange = key;
          break;
      }
    },

    getTimeStampByKey(buttonKey) {
      switch (buttonKey) {
        case "today":
          return {
            from: format(start_of_today(), "X"),
            to: format(end_of_today(), "X")
          };
        case "yesterday":
          return {
            from: format(start_of_yesterday(), "X"),
            to: format(end_of_yesterday(), "X")
          };
        case "last7days":
          return {
            from: format(sub_days(start_of_today(), 6), "X"),
            to: format(end_of_today(), "X")
          };
        case "last14days":
          return {
            from: format(sub_days(start_of_today(), 13), "X"),
            to: format(end_of_today(), "X")
          };
        case "thisYear":
          return {
            from: format(startOfYear(new Date()), "X"),
            to: format(end_of_today(), "X")
          };
        case "lastYear":
          return {
            from: format(subYears(startOfYear(new Date()), 1), "X"),
            to: format(subYears(endOfYear(new Date()), 1), "X")
          };
        default:
         return null;
      }
    },

    saveDateRange(humanName, startTS, endTS) {
      switch (this.granularity) {
        case "day":
          this.$store.commit("setDayDateRange", {
            human: humanName,
            from: startTS,
            to: endTS
          });
          break;
        case "week":
          this.$store.commit("setWeekDateRange", {
            human: humanName,
            from: startTS,
            to: endTS
          });
          break;
        case "year":
          this.$store.commit("setYearDateRange", {
            human: humanName,
            from: startTS,
            to: endTS
          });
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card .md-card-header a {
  color: #333333 !important;
}

.md-card-header .md-button + .md-button {
  margin-left: 0px;
}

.hierarchy-menu {
  margin-right: 2px;
}

li:hover {
  cursor: pointer;
}

.disabled {
  color: #cccccc !important;
  cursor: context-menu;

  font-size: 0.8125rem;
  padding: 10px 1.5rem;
  margin: 0 5px;
  text-transform: none;
  border-radius: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 400;
  line-height: 1.428571;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  white-space: nowrap;
  -webkit-transition: all 150ms linear;
  transition: all 150ms linear;
}

.md-button {
  height: 40px;
}
</style>



